import React, { useRef } from "react";
import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import {
  CompetitorPriceHistoryDate,
  ProductFilterBerand,
  CompetitorPriceLastPrice,
  CompetitorPriceEditeAmount,
  CompetitorPriceSetAmount,
  ProductFilterProducts,
  CompetitorPriceLastPriceProduct,
} from "../../Api/Services";
import ComponentPriceAE from "./ComponentPriceAE";
import { confirmAlert } from "react-confirm-alert";

function CompetitorPriceAE() {
  const [isLoading, setLoading] = useState(true);
  const [Product, setProduct] = useState([]);
  const [LastPrice, setLastPrice] = useState([]);
  const [Amounts, setAmounts] = useState([]);
  const [brands, setBrands] = useState([]);
  const [activeItem, setActiveItem] = useState(null);
  const navigate = useNavigate();
  let { id, extra } = useParams();

  const start = async () => {
    try {
      const ProductFilterProductsData = await ProductFilterProducts({});
      if (
        ProductFilterProductsData.status &&
        ProductFilterProductsData.status === 200
      ) {
        setProduct(ProductFilterProductsData.data.data.data);
        const CompetitorPriceLastPriceProductData =
          await CompetitorPriceLastPriceProduct();
        if (
          CompetitorPriceLastPriceProductData.status &&
          CompetitorPriceLastPriceProductData.status === 200
        ) {
          setLastPrice(CompetitorPriceLastPriceProductData.data.data);
        }
        const ProductFilterBerandData = await ProductFilterBerand({});
        if (
          ProductFilterBerandData.status &&
          ProductFilterBerandData.status === 200
        ) {
          setBrands(ProductFilterBerandData.data.data.data);

          if (extra) {
            const CompetitorPriceHistoryDateData =
              await CompetitorPriceHistoryDate({
                CompetitorId: id,
                Date: extra,
              });
            if (
              CompetitorPriceHistoryDateData.status &&
              CompetitorPriceHistoryDateData.status === 200
            ) {
              let copy = [];
              CompetitorPriceHistoryDateData.data.data.data.map((e) => {
                let data = {
                  Id: e.productId,
                  Price: e.price,
                };
                copy.push(data);
              });
              setAmounts(copy);
            }
          } else {
            const CompetitorPriceLastPriceData =
              await CompetitorPriceLastPrice(id);
            if (
              CompetitorPriceLastPriceData.status &&
              CompetitorPriceLastPriceData.status === 200
            ) {
              let copy = [];
              CompetitorPriceLastPriceData.data.data.data.map((e) => {
                let data = {
                  Id: e.productId,
                  Price: e.price,
                };
                copy.push(data);
              });
              setAmounts(copy);
            }
          }
        }
      }
    } catch (error) {
      console.error("Error during login:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    start();
  }, []);

  const handleClick = (key) => {
    setActiveItem(activeItem === key ? null : key);
  };

  const Add = async () => {
    let validation = true;
    let checkw = Amounts.filter((w) => {
      const product = LastPrice.find((r) => r.productId == w.Id);
      if (!product?.lastPrice) return false;

      return (
        product.lastPrice * 1.1 < w?.Price || product.lastPrice * 0.9 > w?.Price
      );
    });

    if (checkw.length > 0) {
      const dataError = [];

      checkw.forEach((element) => {
        let aa = Product.find((r) => r.id == element.Id);
        const bb = [
          aa.productBerandName != " " && aa.productBerandName + " ",

          aa.productTypeName != " " && aa.productTypeName + " ",

          aa.productSeriesName != " " && aa.productSeriesName,

          aa.symbol,

          aa.productSeriesEndName != " " ? aa.productSeriesEndName + " " : " ",

          aa.productRamName != " " && aa.productRamName + "/",

          aa.productRomName != " " && aa.productRomName + " ",

          aa.productNetworkName != " " && aa.productNetworkName + " ",

          aa.productCountryName != " " && aa.productCountryName + " ",

          aa.isInsurance && "بیمه",
        ]
          .filter(Boolean)
          .join("");

        dataError.push(bb);
      });
      validation = false;
      confirmOk(dataError);
    }

    if (validation) {
      if (extra) {
        setLoading(true);
        try {
          const CompetitorPriceEditeAmountData =
            await CompetitorPriceEditeAmount({
              CreatedDate: extra,
              CompetitorId: id,
              data: Amounts,
            });
          if (
            CompetitorPriceEditeAmountData.status &&
            CompetitorPriceEditeAmountData.status === 200
          ) {
            toast.success("ویرایش قیمت با موفقیت انجام شد");
            navigate("/Panel/CompetitorPrice");
          }
        } catch (error) {
          console.error("Error during login:", error);
        } finally {
          setLoading(false);
        }
      } else {
        setLoading(true);
        try {
          const CompetitorPriceSetAmountData = await CompetitorPriceSetAmount({
            data: Amounts,
            CompetitorId: id,
          });
          if (
            CompetitorPriceSetAmountData.status &&
            CompetitorPriceSetAmountData.status === 200
          ) {
            toast.success("افزودن  قیمت با موفقیت انجام شد");
            navigate("/Panel/CompetitorPrice");
          }
        } catch (error) {
          console.error("Error during login:", error);
        } finally {
          setLoading(false);
        }
      }
    }
  };
  const CheckOk = async () => {
    if (extra) {
      setLoading(true);
      try {
        const CompetitorPriceEditeAmountData = await CompetitorPriceEditeAmount(
          {
            CreatedDate: extra,
            CompetitorId: id,
            data: Amounts,
          },
        );
        if (
          CompetitorPriceEditeAmountData.status &&
          CompetitorPriceEditeAmountData.status === 200
        ) {
          toast.success("ویرایش قیمت با موفقیت انجام شد");
          navigate("/Panel/CompetitorPrice");
        }
      } catch (error) {
        console.error("Error during login:", error);
      } finally {
        setLoading(false);
      }
    } else {
      setLoading(true);
      try {
        const CompetitorPriceSetAmountData = await CompetitorPriceSetAmount({
          data: Amounts,
          CompetitorId: id,
        });
        if (
          CompetitorPriceSetAmountData.status &&
          CompetitorPriceSetAmountData.status === 200
        ) {
          toast.success("افزودن  قیمت با موفقیت انجام شد");
          navigate("/Panel/CompetitorPrice");
        }
      } catch (error) {
        console.error("Error during login:", error);
      } finally {
        setLoading(false);
      }
    }
  };

  const confirmOk = (products) => {
    confirmAlert({
      title: "ایا از انجام این کار مطمئن هستید ",
      message: (
        <>
          <p>کالاهای زیر قیمت خارج از بازه خواهند داشت:</p>

          <ul>
            {products.map((item, index) => (
              <li key={index}>{item}</li>
            ))}
          </ul>
        </>
      ),
      buttons: [
        {
          label: "بله",
          onClick: () => {
            CheckOk();
          },
        },
        {
          label: "خیر",
        },
      ],
    });
  };

  return (
    <div>
      {isLoading && (
        <div className="d-flex justify-content-center align-items-center">
          <div className="lds-facebook">
            <div />
            <div />
            <div />
          </div>
        </div>
      )}
      <div className={isLoading ? "startLoading" : "stateLoading"}>
        <div className="w-100 d-flex justify-content-start align-items-start flex-column element p-5">
          <div className="d-flex justify-content-end align-items-center m-2 w-100">
            <button onClick={Add} className="butAU">
              {extra ? "ویرایش" : "افزودن"}
            </button>
          </div>

          {brands.map(
            (b, key) =>
              Product.filter((e) => e.productBerandId == b.id).length > 0 && (
                <>
                  <div
                    key={b}
                    className="d-flex justify-content-around align-items-center w-100 p-3 mt-4 pointer bg-body-secondary border border-1 border-black"
                    onClick={() => handleClick(b.id)}
                  >
                    <h5>{b.name}</h5>
                  </div>
                  {activeItem === b.id && (
                    <ComponentPriceAE
                      key={key}
                      Product={Product.filter((e) => e.productBerandId == b.id)}
                      Amounts={Amounts}
                      LastPrice={LastPrice}
                      setAmounts={setAmounts}
                    />
                  )}
                </>
              ),
          )}

          <div className="d-flex justify-content-start align-items-center w-100 m-5">
            <button onClick={Add} className="butAU">
              {extra ? "ویرایش" : "افزودن"}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default CompetitorPriceAE;
